// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"31e1a878","239":"427b25e2","488":"080908f2","667":"e3af70b6","941":"a298f209","977":"01627566"}[chunkId] + ".chunk.js";
};